import Vue from 'vue';
import { StorageUtility } from '@codequality/vue-cli-base';

import { Eユーザー権限 } from '@/openapi/enum';
import { ユーザーApi, ユーザーMeResponse } from '@/openapi/user';

import { USER_STORAGE_KEY } from '@/classes/common/Constants';
import UserApiUtility from '@/classes/common/UserApiUtility';

type State = {
  me: ユーザーMeResponse | null;
};

const state = Vue.observable<State>({
  me: null,
});

export default Vue.extend({
  name: 'M企業ユーザーMixin',

  computed: {
    isAuthorized(): boolean {
      return state.me !== null;
    },
    // 以下、isAuthorized === true の場合のみ利用可能
    me(): ユーザーMeResponse {
      return state.me!;
    },
    is管理者(): boolean {
      return this.me.cユーザー権限 === Eユーザー権限.管理者;
    },
    is担当者(): boolean {
      return this.me.cユーザー権限 === Eユーザー権限.担当者;
    },
  },

  methods: {
    async setMe(): Promise<void> {
      let me = StorageUtility.getSessionData<ユーザーMeResponse>(USER_STORAGE_KEY.企業ユーザー);
      if (me === null) {
        const response = await UserApiUtility.ogApi(ユーザーApi).showMe();
        me = response.data;
        StorageUtility.setSessionData(USER_STORAGE_KEY.企業ユーザー, me);
      }
      state.me = me;
    },
    clearMe(): void {
      state.me = null;
      sessionStorage.removeItem(USER_STORAGE_KEY.企業ユーザー);
    },
  },
});
